(() => {
  const init = () => {
    document.querySelectorAll('[data-nivorla-mobile-campaign]').forEach((campaign) => {
      if (campaign.dataset.initialized === 'true') return;
      campaign.dataset.initialized = 'true';

      const slides = [...campaign.querySelectorAll('[data-nivorla-mobile-slide]')];
      const dots = [...campaign.querySelectorAll('[data-nivorla-mobile-dot]')];
      if (slides.length < 2) return;

      let index = 0;
      let timer;
      let touchStartX = 0;

      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const restart = () => {
        window.clearInterval(timer);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => show(index + 1), 5500);
        }
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          show(Number(dot.dataset.nivorlaMobileDot || 0));
          restart();
        });
      });

      campaign.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });

      campaign.addEventListener('touchend', (event) => {
        const delta = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 45) {
          show(index + (delta < 0 ? 1 : -1));
          restart();
        }
      }, { passive: true });

      campaign.addEventListener('mouseenter', () => window.clearInterval(timer));
      campaign.addEventListener('mouseleave', restart);
      show(0);
      restart();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
